import * as React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import HTag from 'components/common/HTag'
import CTALink from 'components/common/CTALink'
import BlueprintGraphic from 'components/BlueprintGraphic'
import Modal from 'components/common/Modal'
import CareersForm from './CareersForm'

const CareersList = ({ heading, description, ctas }) => {
  const { allSanityCareerCategory } = useStaticQuery(query)
  const categories = allSanityCareerCategory.nodes

  const [$open, set$open] = React.useState(false)

  return (
    <section id="careers" className="relative ctnr padding">
      <header className="richtext sm">
        <HTag className="h0" {...heading} />
        {description && <p className="max-w-[470px]">{description}</p>}
      </header>

      <ul className="flex flex-wrap gap-y-4 gap-x-8 items-center justify-center mt-16 <md:grid <md:grid-cols-2">
        {categories?.map((category, key) => (
          <li className="basis-[300px] h3 p-4 text-center transition-colors hover:bg-ft-green/50" key={key}>
            {category.name}
          </li>
        ))}
      </ul>

      <p className="flex flex-wrap items-center gap-4 justify-center mt-12">
        <button className="action lg" onClick={() => set$open(true)}>
          See Current Openings
          <span className="arrow">➞</span>
        </button>

        {ctas?.map((cta, key) => <CTALink {...cta} key={key} />)}
      </p>

      <BlueprintGraphic style={{ bottom: 0, right: 0, width: 'clamp(200px, 40vh, 300px)' }} />

      {$open && (
        <Modal className="max-w-screen-md mx-auto bg-white p-8" onClose={() => set$open(false)}>
          <CareersForm roles={categories} />
        </Modal>
      )}
    </section>
  )
}

export default CareersList

const query = graphql`query CareersList {
  allSanityCareerCategory(sort: {fields: orderRank}) {
    nodes {
      name
    }
  }
}`
